import { gql } from '@apollo/client';

export const EUROTAX_CODES = gql`
  query searchSimilarEurotaxCodes($inputEurotaxCode: String!) {
    searchSimilarEurotaxCodes(inputEurotaxCode: $inputEurotaxCode) {
      label
      eurotaxCode
    }
  }
`;
